import { UpgradeOffer } from '@pubstack/common/src/upgrade'
import { FunctionComponent, ReactNode } from 'react'
import { UpgradeOfferCard } from './UpgradeOfferCard'

type Props = {
  /** What is missing. May be empty, when nothing behind the wall has a product name — see `upgradeDialogCopy`. */
  offers: UpgradeOffer[]
  /** Names the thing the reader just tried to open, when the caller can be more specific than the offer. */
  context?: ReactNode
  /**
   * Anything to say in place of the standard pitch. The offer card is what almost every caller wants, so it
   * is the default rather than something each one has to assemble.
   */
  children?: ReactNode
}

/**
 * The upgrade offer as a modal, over a page that stays worth keeping — the Catalog, which a scope on no
 * product can still browse end to end.
 *
 * Open it through the global modal with `bare`, which hands the surface over so the card below is the modal
 * rather than sitting inside a second white box:
 *
 * ```ts
 * modal.open(UpgradeModal, { offers, context }, { bare: true })
 * ```
 *
 * `bare` is what makes this the same card the locked ad unit tabs draw over their blur — same 860px, same
 * 12px corner, same 32px of padding — instead of `Modal.Body`'s 544px and 4px. The close button is the
 * modal's, floated over the corner: here there is something behind to go back to, which is the whole reason
 * this is a modal and a locked page is not. A locked page shows `UpgradeLockedPanel` instead, which has no
 * dismiss because it has nothing to dismiss to.
 */
export const UpgradeModal: FunctionComponent<Props> = ({ offers, context, children }) => children ?? <UpgradeOfferCard offers={offers} context={context} />
